import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from "react";
import whiteListProps from "./helpers/whiteListProps";
import OrbitIcon from ".";
const createIcon = (def, viewBox, displayName) => {
  const icon = props => /*#__PURE__*/React.createElement(OrbitIcon, _extends({
    viewBox: viewBox
  }, whiteListProps(props)), def);
  icon.displayName = displayName;
  return icon;
};
export default createIcon;